'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.makePie = makePie;
exports.updatePie = updatePie;
var chart = undefined,
    array = undefined;

function makePie(arr, index, func1) {

  array = arr;

  chart = new Highcharts.Chart({
    chart: {
      type: 'pie',
      renderTo: 'left' //,
      //width: 400
      // height: window.innerHeight - 420,
      // events:{
      //   click(e){
      //     console.log(e)
      //   }
      // }
    },
    title: {
      text: '',
      align: 'center',
      verticalAlign: 'top',
      y: 20
    },
    subtitle: {
      text: ''
    },
    tooltip: {
      headerFormat: '<b>{point.key} <b>:<br>',
      pointFormat: '<b>{point.y:.1f} Million$</b><br>{point.percentage:.1f}% of total'
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: true,
          distance: 10,
          style: {
            textShadow: '0px 1px 2px white'
          },
          connectorColor: '#333',
          connectorWidth: 0,
          formatter: function formatter() {
            return "<b>" + this.key + "</b><br/>" + this.percentage.toFixed(1) + "%";
          }
        },
        //showInLegend: true,
        allowPointSelect: true,
        cursor: 'pointer',
        startAngle: -180,
        endAngle: 180,
        center: ['50%', '50%']
      },
      series: {
        name: 'Browser share',
        innerSize: '20%',
        point: {
          events: {
            // select() {
            //   console.log(this.name);
            // },
            // unselect(){
            //   console.log('goneT_T')
            // }
          }
        }
      }
    },
    series: func1(arr, index)
  });
}

function updatePie(index, func2) {
  chart.series[0].setData(func2(array, index));
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9rYXJlbi9Eb2N1bWVudHMvbXlfcHJvamVjdC9mb29kL3NyYy9qcy92aWV3L3BpZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUEsSUFBSSxLQUFLLFlBQUE7SUFBRSxLQUFLLFlBQUEsQ0FBQTs7QUFFVCxTQUFTLE9BQU8sQ0FBQyxHQUFHLEVBQUUsS0FBSyxFQUFFLEtBQUssRUFBQzs7QUFFeEMsT0FBSyxHQUFHLEdBQUcsQ0FBQTs7QUFFWCxPQUFLLEdBQUcsSUFBSSxVQUFVLENBQUMsS0FBSyxDQUFDO0FBQzNCLFNBQUssRUFBRTtBQUNMLFVBQUksRUFBRSxLQUFLO0FBQ1gsY0FBUSxFQUFFLE1BQU07Ozs7Ozs7O0tBUWpCO0FBQ0QsU0FBSyxFQUFFO0FBQ0wsVUFBSSxFQUFFLEVBQUU7QUFDUixXQUFLLEVBQUUsUUFBUTtBQUNmLG1CQUFhLEVBQUUsS0FBSztBQUNwQixPQUFDLEVBQUUsRUFBRTtLQUNOO0FBQ0QsWUFBUSxFQUFFO0FBQ1IsVUFBSSxFQUFFLEVBQUU7S0FDVDtBQUNELFdBQU8sRUFBRTtBQUNQLGtCQUFZLEVBQUUseUJBQXlCO0FBQ3ZDLGlCQUFXLEVBQUUsbUVBQW1FO0tBQ2pGO0FBQ0QsZUFBVyxFQUFFO0FBQ1gsU0FBRyxFQUFFO0FBQ0gsa0JBQVUsRUFBRTtBQUNWLGlCQUFPLEVBQUUsSUFBSTtBQUNiLGtCQUFRLEVBQUUsRUFBRTtBQUNaLGVBQUssRUFBRTtBQUNMLHNCQUFVLEVBQUUsbUJBQW1CO1dBQ2hDO0FBQ0Qsd0JBQWMsRUFBRSxNQUFNO0FBQ3RCLHdCQUFjLEVBQUUsQ0FBQztBQUNqQixtQkFBUyxFQUFBLHFCQUFFO0FBQ1QsbUJBQ0UsS0FBSyxHQUFDLElBQUksQ0FBQyxHQUFHLEdBQUMsV0FBVyxHQUFDLElBQUksQ0FBQyxVQUFVLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxHQUFHLEdBQUcsQ0FDNUQ7V0FDRjtTQUNGOztBQUVELHdCQUFnQixFQUFFLElBQUk7QUFDdEIsY0FBTSxFQUFFLFNBQVM7QUFDakIsa0JBQVUsRUFBRSxDQUFDLEdBQUc7QUFDaEIsZ0JBQVEsRUFBRSxHQUFHO0FBQ2IsY0FBTSxFQUFFLENBQUMsS0FBSyxFQUFFLEtBQUssQ0FBQztPQUN2QjtBQUNELFlBQU0sRUFBQztBQUNMLFlBQUksRUFBRSxlQUFlO0FBQ3JCLGlCQUFTLEVBQUUsS0FBSztBQUNoQixhQUFLLEVBQUM7QUFDSixnQkFBTSxFQUFDOzs7Ozs7O1dBT047U0FDRjtPQUNGO0tBQ0Y7QUFDRCxVQUFNLEVBQUUsS0FBSyxDQUFDLEdBQUcsRUFBRSxLQUFLLENBQUM7R0FDMUIsQ0FBQyxDQUFBO0NBQ0g7O0FBRU0sU0FBUyxTQUFTLENBQUMsS0FBSyxFQUFFLEtBQUssRUFBQztBQUNyQyxPQUFLLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsS0FBSyxFQUFFLEtBQUssQ0FBQyxDQUFDLENBQUE7Q0FDN0MiLCJmaWxlIjoiL1VzZXJzL2thcmVuL0RvY3VtZW50cy9teV9wcm9qZWN0L2Zvb2Qvc3JjL2pzL3ZpZXcvcGllLmpzIiwic291cmNlc0NvbnRlbnQiOlsibGV0IGNoYXJ0LCBhcnJheVxuXG5leHBvcnQgZnVuY3Rpb24gbWFrZVBpZShhcnIsIGluZGV4LCBmdW5jMSl7XG5cbiAgYXJyYXkgPSBhcnJcblxuICBjaGFydCA9IG5ldyBIaWdoY2hhcnRzLkNoYXJ0KHtcbiAgICBjaGFydDoge1xuICAgICAgdHlwZTogJ3BpZScsXG4gICAgICByZW5kZXJUbzogJ2xlZnQnLy8sXG4gICAgICAvL3dpZHRoOiA0MDBcbiAgICAgIC8vIGhlaWdodDogd2luZG93LmlubmVySGVpZ2h0IC0gNDIwLFxuICAgICAgLy8gZXZlbnRzOntcbiAgICAgIC8vICAgY2xpY2soZSl7XG4gICAgICAvLyAgICAgY29uc29sZS5sb2coZSlcbiAgICAgIC8vICAgfVxuICAgICAgLy8gfVxuICAgIH0sXG4gICAgdGl0bGU6IHtcbiAgICAgIHRleHQ6ICcnLFxuICAgICAgYWxpZ246ICdjZW50ZXInLFxuICAgICAgdmVydGljYWxBbGlnbjogJ3RvcCcsXG4gICAgICB5OiAyMFxuICAgIH0sXG4gICAgc3VidGl0bGU6IHtcbiAgICAgIHRleHQ6ICcnXG4gICAgfSxcbiAgICB0b29sdGlwOiB7XG4gICAgICBoZWFkZXJGb3JtYXQ6ICc8Yj57cG9pbnQua2V5fSA8Yj46PGJyPicsXG4gICAgICBwb2ludEZvcm1hdDogJzxiPntwb2ludC55Oi4xZn0gTWlsbGlvbiQ8L2I+PGJyPntwb2ludC5wZXJjZW50YWdlOi4xZn0lIG9mIHRvdGFsJ1xuICAgIH0sXG4gICAgcGxvdE9wdGlvbnM6IHtcbiAgICAgIHBpZToge1xuICAgICAgICBkYXRhTGFiZWxzOiB7XG4gICAgICAgICAgZW5hYmxlZDogdHJ1ZSxcbiAgICAgICAgICBkaXN0YW5jZTogMTAsXG4gICAgICAgICAgc3R5bGU6IHtcbiAgICAgICAgICAgIHRleHRTaGFkb3c6ICcwcHggMXB4IDJweCB3aGl0ZSdcbiAgICAgICAgICB9LFxuICAgICAgICAgIGNvbm5lY3RvckNvbG9yOiAnIzMzMycsXG4gICAgICAgICAgY29ubmVjdG9yV2lkdGg6IDAgICAsXG4gICAgICAgICAgZm9ybWF0dGVyKCl7XG4gICAgICAgICAgICByZXR1cm4oXG4gICAgICAgICAgICAgIFwiPGI+XCIrdGhpcy5rZXkrXCI8L2I+PGJyLz5cIit0aGlzLnBlcmNlbnRhZ2UudG9GaXhlZCgxKSArIFwiJVwiXG4gICAgICAgICAgICApXG4gICAgICAgICAgfSBcbiAgICAgICAgfSxcbiAgICAgICAgLy9zaG93SW5MZWdlbmQ6IHRydWUsXG4gICAgICAgIGFsbG93UG9pbnRTZWxlY3Q6IHRydWUsXG4gICAgICAgIGN1cnNvcjogJ3BvaW50ZXInLFxuICAgICAgICBzdGFydEFuZ2xlOiAtMTgwLFxuICAgICAgICBlbmRBbmdsZTogMTgwLFxuICAgICAgICBjZW50ZXI6IFsnNTAlJywgJzUwJSddXG4gICAgICB9LFxuICAgICAgc2VyaWVzOntcbiAgICAgICAgbmFtZTogJ0Jyb3dzZXIgc2hhcmUnLFxuICAgICAgICBpbm5lclNpemU6ICcyMCUnLFxuICAgICAgICBwb2ludDp7IFxuICAgICAgICAgIGV2ZW50czp7XG4gICAgICAgICAgICAvLyBzZWxlY3QoKSB7XG4gICAgICAgICAgICAvLyAgIGNvbnNvbGUubG9nKHRoaXMubmFtZSk7XG4gICAgICAgICAgICAvLyB9LFxuICAgICAgICAgICAgLy8gdW5zZWxlY3QoKXtcbiAgICAgICAgICAgIC8vICAgY29uc29sZS5sb2coJ2dvbmVUX1QnKVxuICAgICAgICAgICAgLy8gfVxuICAgICAgICAgIH1cbiAgICAgICAgfSAgICAgICBcbiAgICAgIH1cbiAgICB9LFxuICAgIHNlcmllczogZnVuYzEoYXJyLCBpbmRleClcbiAgfSlcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIHVwZGF0ZVBpZShpbmRleCwgZnVuYzIpe1xuICBjaGFydC5zZXJpZXNbMF0uc2V0RGF0YShmdW5jMihhcnJheSwgaW5kZXgpKVxufVxuXG5cbiJdfQ==